var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sx-company" },
    [
      _c(
        "el-select",
        {
          staticClass: "el-select-90",
          attrs: {
            placeholder: "请选择保险公司",
            filterable: true,
            clearable: "",
            disabled: _vm.isDisabled,
            "filter-method": _vm.filterCompany
          },
          on: { clear: _vm.companyClear, change: _vm.supplierChange },
          model: {
            value: _vm.form.companyId,
            callback: function($$v) {
              _vm.$set(_vm.form, "companyId", $$v)
            },
            expression: "form.companyId"
          }
        },
        _vm._l(_vm.companies, function(item) {
          return _c("el-option", {
            key: item.code,
            attrs: { label: item.name, value: item.code }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac4cd310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac4cd310","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sxCompany.vue
// module id = null
// module chunks = 